import React from 'react';
import css from './RadioCircle.module.scss';
import classnames from 'classnames';

const RadioCircle = ({ isActive, isDisabled }) => {
    return (
        <div
            className={classnames(
                css.formRadioCircleWrap,
                isActive ? css.formRadioCircleWrapActive : '',
                isDisabled ? css.formRadioCircleWrapDisabled : ''
            )}
        >
            {isActive && <div className={css.formRadioCircle} />}
        </div>
    );
};

export default RadioCircle;
